import * as angular from "angular";
import "./inputStateDescription.scss"

interface IComponentBindings {
    descriptionId: number
}

export class ComponentController implements angular.IComponentController, IComponentBindings {
    descriptionId: number;

    constructor() {}

}

export class InputStateDescriptionComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: any;

    constructor() {
        this.bindings = {
            descriptionId: "<"
        }
        this.controller = ComponentController;
        this.template = require("./inputStateDescription.html")
    }
}
